
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/asuransi-barang-elektronik",
      function () {
        return require("private-next-pages/asuransi-barang-elektronik.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/asuransi-barang-elektronik"])
      });
    }
  